import { Directive, HostBinding } from '@angular/core';

@Directive()
 
export class AnonymousContentPage {
  @HostBinding('class.nim__content') nimContentClass = true;
}
